import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIrrigationViewer } from '../../hooks/useIrrigationViewer';

/**
 * Pages a farm viewer has no use for (devices, a controller's tools, the
 * network editor) send them back to the overview, where their farms and the
 * Stop button are. See useIrrigationViewer.
 */
export default function NotForFarmViewers({ children }: { children: ReactNode }) {
  const { viewer, loading } = useIrrigationViewer();
  if (loading) return null;
  if (viewer) return <Navigate to="/irrigation" replace />;
  return <>{children}</>;
}
